import React, { useState, useEffect } from "react";

import { useNavigate, useParams } from "react-router-dom";
import SuccessAlert from "./../child/Alert/SuccessAlert";
import DengerAlert from "./../child/Alert/DengerAlert";
import Loader from "./../child/Loder";

const ViewBookingPageNew = () => {
  const [successMessage, setSuccessMessage] = useState(""); // Manage Success Message
  const [errorMessage, setErrorMessage] = useState(""); // Manage Success Message
  const [ItemData, setItemData] = useState([]);
  const [RenterName, setRenterName] = useState("");
  const [HostName, setHostName] = useState("");
  const [newendDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(true); // State to handle loading
  const [cancelling, setCancelling] = useState(false);
  const { id } = useParams();
  const isEditMode = !!id;

  const navigate = useNavigate();

  const fetchBookingData = async () => {
    const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/booking-detail-admin/${id}`;
    try {
      setLoading(true);
      const authToken = localStorage.getItem("authToken");
      const response = await fetch(API_ENDPOINT, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch booking data");
      }

      const datas = await response.json();
      setItemData(datas.data);
      setHostName(datas.data.host.firstName);
      setRenterName(datas.data.renterDetails.name);
      const startDate = new Date(datas.data.startDate);
      let endDate = new Date(startDate);
      switch (datas.data.storageSpace.duration.unit) {
        case "day":
        case "days":
          endDate.setDate(
            endDate.getDate() + datas.data.storageSpace.duration.value
          );
          break;
        case "month":
        case "months":
          endDate.setMonth(
            endDate.getMonth() + datas.data.storageSpace.duration.value
          );
          break;
        case "year":
        case "years":
          endDate.setFullYear(
            endDate.getFullYear() + datas.data.storageSpace.duration.value
          );
          break;
        default:
          throw new Error("Invalid duration unit");
      }

      // Format the end date
      const day = String(endDate.getDate()).padStart(2, "0");
      const month = String(endDate.getMonth() + 1).padStart(2, "0");
      const year = endDate.getFullYear();
      const formattedDate = `${day}-${month}-${year}`;
      // Set and log the result
      setEndDate(formattedDate); // Assuming this is from useState
    } catch (err) {
      setErrorMessage(err.message);
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!id) return;
    fetchBookingData();
  }, [isEditMode, id, navigate]);

  const handleCancelBooking = async () => {
    if (!window.confirm("Are you sure you want to cancel this booking? You will need to manually refund the payment via the Stripe Dashboard. Both parties will be notified.")) {
      return;
    }

    setCancelling(true);
    try {
      const authToken = localStorage.getItem("authToken");
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/admin/updateBookingStatusAdmin/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify({ bookingStatus: "cancelled" }),
        }
      );

      const data = await response.json();
      if (response.ok) {
        setSuccessMessage("Booking cancelled successfully. Refund initiated.");
        setTimeout(() => setSuccessMessage(""), 4000);
        fetchBookingData(); // Refresh to show updated status
      } else {
        setErrorMessage(data.message || "Failed to cancel booking");
        setTimeout(() => setErrorMessage(""), 4000);
      }
    } catch (err) {
      setErrorMessage("Network error: " + err.message);
      setTimeout(() => setErrorMessage(""), 4000);
    } finally {
      setCancelling(false);
    }
  };

  const isActivebooking = ItemData.bookingStatus && ["pending", "approved", "booked"].includes(ItemData.bookingStatus);

  if (loading) return <Loader />;
  return (
    <div className="row gy-4">
      <div className="col-lg-4">
        {successMessage && (
          <SuccessAlert
            message={successMessage}
            onClose={() => setSuccessMessage("")}
          />
        )}
        {errorMessage && (
          <DengerAlert
            message={errorMessage}
            onClose={() => setErrorMessage("")}
          />
        )}
      </div>
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            <ul
              className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
              id="pills-tab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link d-flex align-items-center px-24 active"
                  id="pills-edit-profile-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-edit-profile"
                  type="button"
                  role="tab"
                  aria-controls="pills-edit-profile"
                  aria-selected="true"
                >
                  Booking Information
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link d-flex align-items-center px-24"
                  id="pills-change-passwork-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-change-passwork"
                  type="button"
                  role="tab"
                  aria-controls="pills-change-passwork"
                  aria-selected="false"
                  tabIndex={-1}
                >
                  Dispute Information
                </button>
              </li>
            </ul>
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-edit-profile"
                role="tabpanel"
                aria-labelledby="pills-edit-profile-tab"
                tabIndex={0}
              >
                <span>
                  <b>Booking Detail</b>
                </span>{" "}
                <br></br>
                <div class="row">
                  <div class="col-md-3">
                    <span style={{ display: "flex" }}>
                      <b>Booking Date:</b>
                      {(() => {
                        const date = new Date(ItemData.createdAt);
                        const day = String(date.getDate()).padStart(2, "0");
                        const month = String(date.getMonth() + 1).padStart(
                          2,
                          "0"
                        ); // Ensure month is two digits
                        const year = date.getFullYear();
                        return <p>{`${day}-${month}-${year}`}</p>;
                      })()}
                    </span>
                  </div>
                  <div class="col-md-3">
                    <span style={{ display: "flex" }}>
                      <b>Start Date:</b>
                      {(() => {
                        const date = new Date(ItemData.startDate);
                        const day = String(date.getDate()).padStart(2, "0");
                        const month = String(date.getMonth() + 1).padStart(
                          2,
                          "0"
                        ); // Ensure month is two digits
                        const year = date.getFullYear();
                        return <p>{`${day}-${month}-${year}`}</p>;
                      })()}
                    </span>
                  </div>
                  <div class="col-md-3">
                    <span style={{ display: "flex" }}>
                      <b>End Date:</b>
                      {newendDate}
                    </span>
                  </div>
                  <div class="col-md-3">
                    <span style={{ display: "flex" }}>
                      <b>Price($):</b>
                      {ItemData.amount}
                    </span>
                  </div>
                  <div class="col-md-3">
                    <span style={{ display: "flex" }}>
                      <b>Renter Name:</b>
                      {RenterName}
                    </span>
                  </div>
                  <div class="col-md-3">
                    <spa style={{ display: "flex" }}>
                      <b>Host Name:</b>
                      {HostName}
                    </spa>
                  </div>
                  <br />
                  <div class="col-md-3">
                    <span style={{ display: "flex" }}>
                      <b>Booking Status:</b>
                      {ItemData.bookingStatus}
                    </span>
                  </div>
                </div>
                <br />
                <span>
                  <b>Payment Detail</b>
                </span>
                <br />
                <div class="row">
                  <div class="col-md-3">
                    <span style={{ display: "flex" }}>
                      <b>Payment Status:</b>
                      {ItemData.paymentStatus}
                    </span>
                  </div>
                  <div class="col-md-3">
                    <span style={{ display: "flex" }}>
                      <b>Payment Method:</b>
                      {ItemData.paymentMethod}
                    </span>
                  </div>
                  <div class="col-md-6">
                    <span style={{ display: "flex" }}>
                      <b>Transaction Id:</b>
                      {ItemData.transactionId}
                    </span>
                  </div>
                </div>
                <br />
                {isActivebooking && (
                  <div className="mt-3">
                    <button
                      className="btn btn-danger px-4 py-2"
                      onClick={handleCancelBooking}
                      disabled={cancelling}
                      style={{
                        borderRadius: "8px",
                        fontWeight: "600",
                        fontSize: "14px",
                      }}
                    >
                      {cancelling ? "Cancelling..." : "Cancel Booking"}
                    </button>
                    <span
                      style={{
                        marginLeft: "12px",
                        fontSize: "12px",
                        color: "#888",
                      }}
                    >
                      This will cancel the booking and notify both parties.
                      <br /><b>Note:</b> You must manually refund the payment via the Stripe Dashboard.
                    </span>
                  </div>
                )}
              </div>
              <div
                className="tab-pane fade"
                id="pills-change-passwork"
                role="tabpanel"
                aria-labelledby="pills-change-passwork-tab"
                tabIndex="0"
              >
                <div class="col-md-3">
                  <span>No Data Found</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewBookingPageNew;

